import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { Subject, takeUntil } from 'rxjs';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import { DrawerService } from '../../../../../../core/services/drawer.service';
import { AuditType } from '../../../../../bip-template/bip-template.enums';
import { DataLogDetailParams, DataLogs } from '../data-log.interface';
import { UserDatePipe } from '../../../../../../shared/pipes/user-date.pipe';

@Component({
  selector: 'app-data-log-detail',
  standalone: true,
  imports: [SvgIconComponent, NzDividerModule, CommonModule, UserDatePipe],
  templateUrl: './data-log-detail.component.html',
  styleUrl: './data-log-detail.component.scss',
})
export class DataLogDetailComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  logDetail: DataLogs | null = null;
  AuditTypeEnums = AuditType;
  constructor(private drawerService: DrawerService) {
    this.setupDrawerParams();
  }

  private setupDrawerParams(): void {
    this.drawerService
      .getParams<DataLogDetailParams>(DRAWER_IDS.DATA_LOG_DETAIL)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.logDetail = params.selectedLog;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
